module.exports = __webpack_public_path__ + "80e23a6773a5debd3542611789b0ef7f.svg";